<template>
    <div>
        <van-nav-bar
            :title="name"
            left-arrow
            :fixed="true"
            @click-left="goback()"
        />
        <common-scrom :id="+scrom.resId" />
    </div>
</template>
<script>
let taskId = 0;
let courseItemId = 0;
let courseId = 0;
let enterFullPath = {
    path:'',
    query:null,
}
import CommonScrom from "./commonScrom.vue";
export default {
    name:'PlayScrom',
    components:{
        CommonScrom
    },
    data(){
        return{
            scrom: {
                name:'Scorm',
                resId: 0,
                cleartime:null,
                duration:0,
            },
        }
    },
    methods:{
        goback(){
            if(this.$isapp){
                this.$WDJSBridge.useBack()
            }else{
                this.$router.go(-1);
            }
        },
        async saveLearningLog() {
            const data = {
                courseId:courseId,
                taskId: taskId || '',
                courseItemId: courseItemId,
                cur: 5 || 1,
                max: 5 || 1,
                pollingTime: 5,
                taskType:2
            }
            return await this.$api.course.postCourseLearningLogSaveLog({ data }).then(res => {
                console.debug(res)
            })
        },
         async postUserLearningLog () {
            const data = {
                learningLength: 5
            }
            await this.$api.course.postUserLearningLog({ data }).then(res => {
                console.debug(res)
            })
        },
    },
    beforeDestroy(){
        clearInterval(this.cleartime)
    },
    created(){
        taskId = this.$route.query.taskId;
        courseItemId = this.$route.query.courseItemId;
        courseId =  this.$route.query.courseId;
        this.scrom.resId = this.$route.query.resId;
        this.name = this.$route.query.name;
    },
    mounted(){
        this.cleartime=setInterval(val=>{
            this.saveLearningLog();
            this.postUserLearningLog();
        },5000)
    },
    beforeRouteEnter (to, from, next) {
        enterFullPath.path = from.path;
        enterFullPath.query = from.query;
        next();
    }
}
</script>
